/** DVA namespace — must match `model.js` and Launchpad (`ReportsActionsHost`). */
export const MODEL_NAME = 'manageReports';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'report';

/** Singular entity name for `createCrudModel` reducers/notifications. Often equals `FETCH_ROUTE`. */
export const ENTITY_NAME = 'report';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'reports';
